export const takeLongest = (arrays: string[][]) => {
  let max: string[] = arrays[0];
  arrays.forEach((array) => {
    if (array.length > max.length) {
      max = array;
    }
  });

  return max;
};

export const getInteractionData = (
  benchmarkTimeseries: [Date, number][],
  portfolioTimeseries: [Date, number][]
) => {
  // Transform data sets into the same format
  const dataSets = {
    benchmark: benchmarkTimeseries.reduce((benchmarkMap, list) => {
      // Use date portion of ISO string as the key
      benchmarkMap[list[0].toISOString().slice(0, 10)] = list[1];
      return benchmarkMap;
    }, {}),
    portfolio: portfolioTimeseries.reduce((portfolioMap, list) => {
      // Use date portion of ISO string as the key
      portfolioMap[list[0].toISOString().slice(0, 10)] = list[1];
      return portfolioMap;
    }, {}),
  };

  const dateLists = Object.values(dataSets).map((n) => Object.keys(n));

  return takeLongest(dateLists).reduce<
    Record<
      string,
      {
        benchmark?: number;
        portfolio?: number;
      }
    >
  >((interactionData, date) => {
    const benchmark = dataSets.benchmark[date];
    const portfolio = dataSets.portfolio[date];
    interactionData[date] = {
      benchmark,
      portfolio,
    };
    return interactionData;
  }, {});
};
